import { SmartSendItemApiModel } from '~/lib/api/smartsend/types';

import { EditType } from './EditType';
import { SettingsCache } from '~/lib/consts/settings-cache';
import { lazy, Suspense } from 'react';
import { useHasEntitlement } from '~/hooks/use-entitlements';

const Alternatives = lazy(() => import('./Alternatives'));

const AlternativesWrapper = ({
  onEdit,
  item
}: {
  onEdit: (editType: EditType) => void;
  item: SmartSendItemApiModel;
}) => {
  const enabledViaSubscription = useHasEntitlement('shipping_recommendations');
  const enabled =
    (enabledViaSubscription || SettingsCache.settings.Features.includes('InlineQuoteSuggestions')) &&
    !!item?.Service?.Id;

  return enabled ? (
    <Suspense fallback={null}>
      <Alternatives onEdit={onEdit} item={item} />
    </Suspense>
  ) : null;
};

export default AlternativesWrapper;
